<template>
    <div v-if="user.strava_connected == 1 && user.strava_enabled == 1" class="kgk-sync-strava-btn">
            <button type="button" @click.prevent="syncToStrava()" :disabled="loading">
                <i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-sync'"></i>
                <span class="button-text">Hole Läufe von Strava</span>
            </button>
    </div>
  </template>

  <script>
  import user from '../../api/user';

  export default {
    props: ['user'],
    data() {
        return {
            strava: {},
            // Local state -- `loading` used to be a prop that no parent ever
            // bound, so writing to it only produced a Vue prop-mutation
            // warning and never actually disabled the button.
            loading: false,
        }
    },
    methods: {

      syncToStrava() {
        this.loading = true;

        user.stravaSyncronize(
            this,
            data => {
                this.strava = data;

                // Older backend responses omit rateCheck entirely; treat a
                // missing envelope as "not rate limited" instead of throwing
                // inside the success handler (which surfaced as a bogus
                // network error and skipped the refresh emit below).
                const status = (data && data.rateCheck && data.rateCheck.status) || 200;
                const imported = (data && data.imported) || 0;
                const alreadyImported = (data && data.already_imported) || 0;

                switch (status) {
                    case 200:
                        if (imported > 0) {
                            this.$notify({
                                type: 'success',
                                title: 'Läufe importiert',
                                text: `<b>${imported}</b> Läufe wurden erfolgreich importiert.`
                            });
                        } else if (alreadyImported > 0) {
                            this.$notify({
                                type: 'success',
                                title: 'Keine neuen Läufe',
                                text: 'Alle Läufe aus Strava sind bereits importiert.'
                            });
                        } else {
                            this.$notify({
                                type: 'warn',
                                title: 'Lauf import',
                                text: `Es wurden <b>${imported}</b> Läufe gefunden. Stelle sicher, dass sie in Strava verfügbar sind.`
                            });
                        }

                        break;
                    case 86:
                        this.$notify({
                            type: 'error',
                            title: 'Läufe <b>nicht</b> importiert.',
                            text: `Bitte warte noch <b>${data.rateCheck.waitTime}</b> Minuten und versuche dann erneut einen Import.`
                        });
                        break;
                    case 87:
                        this.$notify({
                            type: 'error',
                            title: 'Läufe <b>nicht</b> importiert.',
                            text: 'Dein Limit für importe ist heute leider erschöpft. Bitte versuche es morgen noch einmal.'
                        });
                        break;
                    case 88:
                        this.$notify({
                            type: 'error',
                            title: 'Läufe <b>nicht</b> importiert.',
                            text: 'Das Limit für importe ist heute leider erschöpft. Bitte versuche es morgen noch einmal.'
                        });
                        break;
                    case 89:
                        this.$notify({
                            type: 'error',
                            title: 'Läufe <b>nicht</b> importiert.',
                            text: 'Bitte warte 15 Minuten und versuche es dann erneut.'
                        });
                        break;
                    default:
                        break;
                }

                // Always reload the list: even when nothing was imported this
                // is the cheapest way to pick up runs added by a parallel
                // sync, and on the import path it is what makes the new runs
                // appear without a page reload.
                this.$emit('imported');
            },
            e => {
                const response = e && e.response;
                const payload = (response && response.data) || {};

                this.$notify({
                    type: 'error',
                    title: 'Läufe <b>nicht</b> importiert.',
                    text: payload.message || 'Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.',
                });
            },
            () => this.loading = false,
        );
      },

    }
  }
  </script>

  <style scoped>
  /* Hier kannst du dein CSS für das ConnectStrava-Template hinzufügen */
  /*  */
  </style>
